<template>
  <div
    class="flex items-center justify-center w-full h-screen bg-img vx-row no-gutter"
    id="page-login"
  >
    <div class="m-0 vx-col">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="items-center justify-center vx-row no-gutter">
            <div class="vx-col d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="mb-10 vx-card__title" style="width: 45vh;">
                  <img src="@/assets/images/logo/logo.png" class="mx-auto" style="max-width: 35vh;" />
                </div>

                <div>
                  <ValidationObserver v-slot="{ invalid }">
                    <ValidationProvider
                      passes
                      name="email address"
                      rules="required|email"
                      v-slot="{ errors }"
                    >
                      <vs-input
                        name="email"
                        icon-no-border
                        icon="icon icon-mail"
                        icon-pack="feather"
                        label-placeholder="Email address"
                        v-model="email"
                        class="w-full"
                        :success="errors.length === 0"
                        success-text="Email address is valid"
                        :danger="errors.length > 0"
                        :danger-text="errors[0]"
                      />
                    </ValidationProvider>
                    <ValidationProvider
                      passes
                      name="password"
                      rules="required|min:6|max:30"
                      v-slot="{ errors }"
                    >
                      <vs-input
                        type="password"
                        name="password"
                        icon-no-border
                        icon="icon icon-lock"
                        icon-pack="feather"
                        label-placeholder="Password"
                        v-model="password"
                        class="w-full mt-6"
                        :success="errors.length === 0"
                        success-text="Password is valid"
                        :danger="errors.length > 0"
                        :danger-text="errors[0]"
                      />
                    </ValidationProvider>
                    <vs-alert :active="isError" class="mt-2" color="danger" icon="new_releases">
                      <span>{{error_message}}</span>
                    </vs-alert>
                    <div class="flex flex-wrap justify-between my-5">
                      <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
                      <router-link :to="{name: 'reset-password'}">Forgot your password?</router-link>
                    </div>
                    <router-link :to="{name: 'register'}">
                      <vs-button type="border">Register</vs-button>
                    </router-link>
                    <vs-button
                      class="float-right"
                      :disabled="invalid || email === '' || password === ''"
                      @click.prevent="login"
                    >Login</vs-button>
                  </ValidationObserver>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <div style="right: auto; left: 10px; top: auto; bottom:30px; position: absolute;" v-if="!isClosed">
      <div class="flex p-4 m-8 mx-auto bg-white rounded-lg shadow-lg notification-box">
        <div class="pr-2">
          <i class="pt-4 mr-2 fa fa-credit-card" style="font-size: 2rem;"></i>
        </div>
        <div>
          <div class="pb-2 text-sm">
            <span>Announcement</span>
            <span class="float-right" @click="isClosed = true" style="cursor: pointer;">
              <svg
                class="text-gray-600 fill-current"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="22"
                height="22"
              >
                <path
                  class="heroicon-ui"
                  d="M16.24 14.83a1 1 0 0 1-1.41 1.41L12 13.41l-2.83 2.83a1 1 0 0 1-1.41-1.41L10.59 12 7.76 9.17a1 1 0 0 1 1.41-1.41L12 10.59l2.83-2.83a1 1 0 0 1 1.41 1.41L13.41 12l2.83 2.83z"
                />
              </svg>
            </span>
          </div>
          <div
            class="text-sm tracking-tight text-gray-600"
            @click="$router.push('/pricing')"
            style="cursor:pointer;"
          >Click here to see pricing details without login.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      password: '',
      isError: false,
      error_message: '',
      isClosed: false,
      checkbox_remember_me: false
    }
  },
  methods: {
    async login () {
      this.$http
        .post('/auth/local', { email: this.email, password: this.password})
        .then(res => {
          if (res.data && res.data.status === true) {
            this.$router.push('/dashboard')
            this.$swal({
              position: 'bottom-end',
              icon: 'success',
              toast: true,
              title: 'Successfully logged in, redirecting...',
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true
            })
          }
        })
        .catch(err => {
          this.isError = true
          this.error_message = err.response.data.message
        })
    }
  },
  created(){
    clearInterval(localStorage.notifier);
  }
}
</script>
<style>
.notification-box {
  width: 25rem;
}
</style>
